"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const HasLength_1 = require("../../shared/HasLength");
const HasSize_1 = require("../../shared/HasSize");
class IsNotEmptyValidator {
    isValid(input) {
        if (HasLength_1.hasLength(input)) {
            return input.length > 0;
        }
        else if (HasSize_1.hasSize(input)) {
            return input.size > 0;
        }
        else {
            return false;
        }
    }
}
exports.IsNotEmptyValidator = IsNotEmptyValidator;
//# sourceMappingURL=IsNotEmptyValidator.js.map